import YouTubePlayer from 'youtube-player'

// YouTube player states — https://developers.google.com/youtube/iframe_api_reference#Playback_status
const ENDED = 0
const PLAYING = 1

export default class YouTubeVideo {
    constructor(el) {
        this.el = el
        this.wrapper = this.el.querySelector('.video-wrapper')
        this.video = this.el.querySelector('.video')
        this.play = this.el.querySelector('.play-btn')
        this.id = this.video.getAttribute('data-id')
        this.hasLoaded = false

        this.play.addEventListener('click', () => {
            if (this.hasLoaded) {
                this.wrapper.classList.add('playing')
                this.player.playVideo()

                return
            }

            this.load()
        })
    }

    load() {
        this.wrapper.classList.add('loading')

        this.player = YouTubePlayer(this.video, {
            videoId: this.id,
            width: '100%',
            height: '100%',
            playerVars: {
                autoplay: 1,
                rel: 0,
                modestbranding: 1,
                playsinline: 1,
            },
        })

        this.player.on('stateChange', (event) => this.onStateChange(event))
    }

    onStateChange(event) {
        switch (event.data) {
            case PLAYING:
                this.hasLoaded = true
                this.wrapper.classList.remove('loading')
                this.wrapper.classList.add('playing')
                break

            case ENDED:
                this.wrapper.classList.remove('playing')
                break
        }
    }
}